import { jsx as a } from "react/jsx-runtime";
import m from "../Snackbar/Snackbar.js";
import { toast as f } from "react-toastify";
const n = (o, t, r) => {
  f(
    ({ closeToast: s }) => /* @__PURE__ */ a(m, { onClose: s, severity: o, msg: t }),
    r
  );
};
export {
  n as default
};
//# sourceMappingURL=showToast.js.map
